/**
 * @format
 * @Ageat
 */

import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../../Contexts/EventContext';
import ModalCustom from '../../../Shared/Components/ModalCustom';
import Pagination from '../../../Shared/Components/Pagination';
import { error, success } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { useAccess } from '../../../Shared/hooks/useAccess';
import Master from '../../Layouts/Master';

const Age = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [ageRemoveId, setAgeRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { canManageBaseData } = useAccess();

  useEffect(() => {
    getAge();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  const getAge = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/base/age/${search}`,
      {},
      (res) => {
        eventContext.ages = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeAge = async (ageId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/panel/base/age/${ageId}`,
      {},
      (res) => {
        success('رده سنی مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getAge();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست رده سنی
          </h1>
        </div>
        {canManageBaseData() && (
          <Link
            to='/panel/base-define/Age/create'
            className='d-flex flex-row btn btn-outline-info '
          >
            <i className='fad fa-plus f-16 mx-2'></i>
            <span className='f-13'>ایجاد رده سنی</span>
          </Link>
        )}
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.ages?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>شروع رده</th>
                <th>پایان رده</th>
                <th>رشته</th>
                <th>وضعیت</th>
                {canManageBaseData() && <th>عملیات</th>}
              </tr>
            </thead>
            <tbody>
              {eventContext.ages?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.title}</td>
                  <td>
                    {moment(item.start_age ?? '1990-01-01', 'YYYY-MM-DD')
                      .locale('fa')
                      .format('YYYY/MM/DD')}
                  </td>
                  <td>
                    {moment(item.end_age ?? '1990-01-01', 'YYYY-MM-DD')
                      .locale('fa')
                      .format('YYYY/MM/DD')}
                  </td>
                  <td>{item?.sport?.name_fa}</td>
                  <td>
                    <span
                      className={`badge badge-${
                        item.status === 0 ? 'danger' : 'success'
                      } badge-pill p-2`}
                    >
                      {item.status === 0 ? 'غیرفعال' : 'فعال'}
                    </span>
                  </td>
                  {canManageBaseData() && (
                    <td>
                      <div className='d-flex flex-row'>
                        <Link
                          to={`/panel/base-define/Age/edit/${item.id}`}
                          className='mx-2'
                        >
                          ویرایش
                        </Link>
                        {canManageBaseData() && (
                          <Link
                            className='mx-2'
                            to='#'
                            onClick={(e) => {
                              e.preventDefault();
                              setAgeRemoveId(item.id);
                              setModalIsOpen(true);
                            }}
                          >
                            حذف
                          </Link>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد رده سنی بر روی منوی ایجاد رده سنی کلیک کنید
            </span>
          </div>
        )}
      </div>
      <div className='w-100 mt-4 d-flex'>
        <Pagination
          totalPage={eventContext.ages?.meta?.pagination?.total_pages}
          basePath='/panel/base-define/age'
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف رده سنی مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeAge(ageRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Age;
